import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setLogout } from "../loginForm";

export const useAuth = () => {
    const dispatch = useDispatch()
    const isLogin = useSelector((state) => state.auth.isLogin)
    const userData = useSelector((state) => state.auth.userData)
    const token = useSelector((state) => state.auth.token)
    const token2 = localStorage.getItem('werkenDeIn_user_token')
    if (isLogin === true && (!userData || !token || !token2)) {
        console.log(isLogin);
        if (isLogin === false) {
            return false
        }
        toast.warn("Sorry, we couldn't find your account. Please sign in again.")
        dispatch(setLogout())
    }

    if (isLogin === true && userData && token && token2) {
        return true;
    } else {
        return false
    }

};